<template>
  <vertical-level>
    <p v-for="value in values" :key="value.label" class="vlevel-item">
      <span class="has-text-weight-semibold">{{ value.label }}: </span>
      <router-link v-if="value.link" :to="value.link">{{ value.value }}</router-link>
      <span v-else>{{ value.value }}</span>
    </p>
    <slot></slot>
  </vertical-level>
</template>

<script>
import VerticalLevel from '@/components/VerticalLevel.vue';

export default {
  name: 'VerticalKeyValue',
  components: { VerticalLevel },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
